import { webKnots } from '../../../../common/back/lace/webKnots'
import { middleSidePartOfWeb, topSidePartOfWeb } from './parts/sideParts'
import { verticalPartOfWebWithLace } from './parts/verticalParts'

export const crossDoubleWebWithLace = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  // 横上パーツ
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -20, 35, -5, 1.02)
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, 70, 175, -5, 0.8)
  verticalPartOfWebWithLace(ctx, webColor, laceColor, stitchColor)
  webKnots(ctx, laceColor, -80, 90) // クロス中央の結び目
  webKnots(ctx, laceColor, -105, 110) // 捕球面上のウェブ結び目
}
